module.exports = __webpack_public_path__ + "img/2.f0a8a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/2.png
// module id = wYHo
// module chunks = 1